import { CalendarIcon } from '@radix-ui/react-icons';
import { Flex } from 'reflexbox';
import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const SearchInput = styled.div<{disabled?}>(
  ({ disabled }) => `
  margin: 0;
  font-size: 12px;
  color: #000;
  width: 100%;
  border: 1px solid ${disabled ? 'rgba(233, 233, 233, 0.7)' : '#BABABA'};
  border-radius: 8px;
  box-sizing: border-box !important;
  display: inline-flex;
  background-color: #fff;
  height: 20px;
`,
);

export const Label = styled.span`
  position: relative;
  display: inline-block;
  margin-left: 16px;
  margin-right: 16px;
  color: #202370;
  font-size: 11px;
  font-weight: bold;
`;

export const CleanBtn = styled.div`
  cursor: pointer;
  color: ${colors.BlueSecondary};
  margin-left: 18px;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 600;

  &:hover {
    color: ${colors.Blue400};
  }
`;

export const ControlFilter = styled.div`
  color: ${colors.BlueSecondary};
  border: 1px solid ${colors.BlueSecondary};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;

export const ContainerArea = styled.div`
  width: 100%;
  min-width: 80px;
  .select-search__input {
    font-size: 12px;
    height: 15px;
  }
  .select-search__option {
    height: auto;
    min-height: 36px;
  }

  .select-search__select {
    width: 225px;
    position: relative;
    z-index: 100 !important;
  }
`;

export const FiltersContainer = styled(Flex)<{ showFilter?: boolean }>(({ showFilter }) => `
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  border-bottom: ${showFilter ? `2px solid ${colors.Grey100}` : 'none'};
  padding: ${`${showFilter ? '24px 20px 16px 20px' : '0'}`};
  background-color: ${showFilter ? '#f8f8f8' : '#ffffff'};
`);

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 2;
  position: absolute;
  overflow: hidden;
  background-color: ${`${colors.Grey030}99`};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentDate = styled.div`
  /* Input de data */
  position: relative;
  border: 1px solid #BABABA;
  border-radius: 8px;
  height: 41px;
  width: 226px;
  background-color: white;
  .react-datepicker__month-text--keyboard-selected {
    background-color: ${colors.BlueSecondary};
    color: white;
  }
  .CalendarMonth_caption {
    text-transform: capitalize;
  }
  .react-datepicker__triangle {
    left: -130px !important;
  }
  .react-datepicker__header {
    background-color: white;
    border-bottom: none;
  }

  .react-datepicker-popper {
    z-index: 99;
  }
  .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::after {
    display: none;
  }

  .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
    display: none;
  }
  .react-datepicker-wrapper {
    display: block;
    .react-datepicker__input-container {
      top: -5px;
      input[type="text"] {
        border: none;
        font-size: 12px;
        outline: none;
        line-height: 19px;
        padding: 0 40px 0 14px;
        color: #464555;
        background: transparent;
      }
    }
  }
  .SingleDatePicker {
    display: block;
    position: initial;
  }
  .SingleDatePickerInput {
    display: block;
    position: relative;
    border: none;
    background: transparent;
    z-index: 10;
    top: -30px;
    .DateInput {
      display: block;
      position: relative;
      width: 100%;
      background: transparent;
      /* Valor que aparece no input */
      .DateInput_input {
        position: relative;
        top: 25px;
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0 40px 0 14px;
        font-weight: 300;
        color: ${colors.Grey400};
        width: 100%;
        background: transparent;
        border: none;
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .DateRangePickerInput {
    .DateRangePickerInput_arrow {
      width: 60px;
    }
    .DateInput {
      .DateInput_input {
        outline: none;
        font-size: 12px;
        line-height: 19px;
        padding: 0 40px 0 14px;
        color: ${colors.Grey400};
      }
      .DateInput_input__focused {
        border: none;
      }
    }
  }
  .DateInput_fang {
    z-index: 1;
  }
  .SingleDatePicker_picker {
    width: 100%;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.White};
    font-weight: bold;
  }
  .CalendarDay__selected:hover {
    background: ${colors.BlueSecondary};
    border: 1px double ${colors.BlueSecondary};
    color: ${colors.Black};
  }
  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    border-right: 33px solid ${colors.BlueSecondary};
    display: none;
  }
  .DayPickerKeyboardShortcuts_show__bottomRight:hover::before {
    border-right: 33px solid ${colors.BlueSecondary};
  }
`;

export const ContainerSearch = styled.div`
  position: relative;
  span {
    top: calc(50% - 19px);
  }
  label:focus-within span {
    font-size: 11px;
    top: calc(50% - 19px);
  }
  label {
    font-size: 11px;
  }
  input::placeholder {
    padding-top: 4px;
    font-size: 12px;
  }
  input {
    height: 39px;
    width: 224px;
    min-height: 39px;
    padding: 15px 16px 0;
  }
  div:first-child {
    border: 1px solid ${colors.Grey200};
  }
`;

export const DateLabel = styled.span`
  transition: all 0.2s;
  margin-left: 14px;
  margin-right: 5px;

  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  color: #202370;
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  position: absolute;
  top: 17px;
  right: 16px;
`;
